// extracted by mini-css-extract-plugin
module.exports = {"page":"dynamo-dynamic-page_page__qqduP","page__body":"dynamo-dynamic-page_page__body__lnMua","page__footer":"dynamo-dynamic-page_page__footer__fgY9K"};